
import { defineComponent } from "vue";
import { PostNotFoundError } from "@/views/post/BasePostView.vue";
import MiniPlayerComponent from "@/components/player/MiniPlayerComponent.vue";
import MiniShareOverlayComponent from "@/components/share/MiniShareOverlayComponent.vue";
import { EmbedType } from "@/providers/analytics.provider";
import MiniPlayerLoadingComponent from "@/components/player/MiniPlayerLoadingComponent.vue";
import BasePostView from "@/views/post/BasePostView.vue";

export default defineComponent({
    name: "MiniPostView",
    components: {MiniPlayerLoadingComponent, MiniPlayerComponent, MiniShareOverlayComponent },
    extends: BasePostView,
    data() {
        return { embedType: EmbedType.PostMini, PostNotFoundError };
    },
});
